import styled from 'styled-components';

const SocialLinksList = styled.ul`
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  ${({ theme }) => theme.breakPoints.minBp('desktop')} {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  &.large {
    button {
      padding: ${({ theme }) => theme.spacing(12)};
    }
  }
  &.xlarge {
    button {
      padding: ${({ theme }) => theme.spacing(16)};
    }
  }

  li {
    a {
      .linkedin {
        transform: scale(2);
        top: 12px;
        position: relative;
      }
    }
    ${({ theme }) => theme.breakPoints.minBp('desktop')} {
      margin-right: ${({ theme }) => theme.spacing(20)};
      margin-bottom: ${({ theme }) => theme.spacing(20)};

      &:last-of-type {
        margin-right: 0;
      }
    }
  }
`;
export default SocialLinksList;